// extracted by mini-css-extract-plugin
export default {"box":"form1_box__+MC5z","input":"form1_input__v9fKU"};